<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-form>
              <b-form-group
                label="Bộ lọc"
                class="border border-primary rounded p-50"
                label-class="pb-25"
              >
                <b-row>
                  <b-col cols="12" md="4">
                    <b-form-group
                      label="Hệ đào tạo:"
                      label-for="trainingSystemSelected"
                    >
                      <v-select
                        v-model="trainingSystemSelected"
                        :options="trainingSystemsOptions"
                        :reduce="option => option.value"
                        @input="onChangeTrainingSystem"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group
                      label="Khóa học:"
                      label-for="courseSelected"
                    >
                      <v-select
                        v-model="courseSelected"
                        :options="courseOptions"
                        :reduce="option => option.value"
                        @input="onChangeCourse"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group
                      label="Ngành học:"
                      label-for="majorSelected"
                    >
                      <v-select
                        v-model="majorSelected"
                        :options="majorOptions"
                        :reduce="option => option.value"
                        @input="onChangeMajor"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="4">
                    <b-form-group
                      label="Lớp học:"
                      label-for="classSelect"
                    >
                      <v-select
                        v-model="classSelect"
                        :options="classOptions"
                        :reduce="option => option.value"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group
                      label="Học kỳ:"
                      label-for="semesterSelected"
                    >
                      <v-select
                        v-model="semesterSelected"
                        :options="semesterOptions"
                        :reduce="option => option.value"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-form>
            <b-row>
              <b-col cols="12">
                <div class="text-right">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    style="margin-right: 5px"
                    :disabled="!(classSelect > 0 && semesterSelected > 0)"
                    @click="onSelect"
                  >
                    <feather-icon icon="ListIcon" /> Danh sách
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    style="margin-right: 5px"
                    :disabled="!(itemsTable.length > 0 && semesterSelected > 0)"
                    @click="exportExcel"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="DownloadIcon" /> Xuất excel
                    </span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12">
                <div>
                  <b-table
                    ref="table"
                    :small="true"
                    :hover="true"
                    :items="itemsTable"
                    :fields="fieldsTable"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BContainer, BForm, BFormGroup, BOverlay, BRow, BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import { showErrorToast } from '@/utils/notification'

export default {
  name: 'ClassReceiptsCourseSemester',
  directives: {
    Ripple,
  },
  components: {
    BTable,
    BButton,
    BFormGroup,
    BForm,
    BCard,
    BCol,
    BContainer,
    BOverlay,
    BRow,
    vSelect,
  },
  data() {
    return {
      trainingSystemSelected: undefined,
      courseSelected: undefined,
      majorSelected: undefined,
      classSelect: undefined,
      semesterSelected: undefined,
      isLoading: false,
      contentRendered: false,
      generatingPdf: false,
      pdfDownloaded: false,
      controlValue: {
        showLayout: false,
        floatLayout: true,
        enableDownload: true,
        previewModal: true,
        paginateElementsByHeight: 1100,
        manualPagination: false,
        filename: 'Danhsachphach',
        pdfQuality: 2,
        pdfFormat: 'a4',
        pdfOrientation: 'portrait',
        pdfContentWidth: '800px',
      },
      contentPdf: {
        heDaoTao: 'Đại học chính quy',
        lop: null,
        namHoc: null,
        hocKy: null,
        phongThi: null,
        monHoc: null,
        lanThi: 1,
      },
      fieldsTable: [
        { key: 'index', label: '#' },
        { key: 'student_code', label: 'Mã sinh viên' },
        { key: 'last_name', label: 'Họ' },
        { key: 'first_name', label: 'Tên' },
        { key: 'birthday', label: 'Ngày sinh' },
        { key: 'class_name', label: 'Lớp' },
        { key: 'major_name', label: 'Ngành' },
        { key: 'total', label: 'Phải nộp' },
        { key: 'total_exemption', label: 'Miễn giảm' },
        { key: 'amount', label: 'Tổng phải nộp' },
        { key: 'is_receipts', label: 'Trạng thái' },
      ],
      itemsTable: [],
    }
  },
  computed: {
    ...mapGetters({
      dataLists: 'classReceiptsCourseSemester/dataLists',
      allTrainingSystems: 'classReceiptsCourseSemester/allTrainingSystems',
      listTrainingSystemCourses: 'classReceiptsCourseSemester/listTrainingSystemCourses',
      listCourseMajors: 'classReceiptsCourseSemester/listCourseMajors',
      listCourseMajorClasses: 'classReceiptsCourseSemester/listCourseMajorClasses',
      allSemesters: 'classReceiptsCourseSemester/allSemesters',
    }),
    htmlToPdfOptions() {
      return {
        margin: 0,
        filename: 'Danhsachphach.pdf',
        image: {
          type: 'jpeg',
          quality: 0.98,
        },
        enableLinks: true,
        html2canvas: {
          scale: this.controlValue.pdfQuality,
          useCORS: true,
        },
        jsPDF: {
          unit: 'in',
          format: this.controlValue.pdfFormat,
          orientation: this.controlValue.pdfOrientation,
        },
      }
    },

    trainingSystemsOptions() {
      return this.allTrainingSystems.map(item => ({ value: item.id, label: item.name }))
    },
    courseOptions() {
      return this.listTrainingSystemCourses.map(item => ({ value: item.id, label: item.name }))
    },
    majorOptions() {
      return this.listCourseMajors.map(item => ({ value: item.id, label: item.name }))
    },
    classOptions() {
      return this.listCourseMajorClasses.map(item => ({ value: item.id, label: item.name }))
    },
    semesterOptions() {
      return this.allSemesters.map(item => ({ value: item.id, label: item.name }))
    },
  },
  async created() {
    this.isLoading = true
    try {
      await Promise.all([
        this.begin(),
      ])
    } catch (e) {
      showErrorToast(this, e)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions({
      begin: 'classReceiptsCourseSemester/begin',
      getData: 'classReceiptsCourseSemester/getData',
      getListTrainingSystemCourses: 'classReceiptsCourseSemester/getListTrainingSystemCourses',
      getListCourseMajors: 'classReceiptsCourseSemester/getListCourseMajors',
      getListCourseMajorClasses: 'classReceiptsCourseSemester/getListCourseMajorClasses',
    }),

    onChangeTrainingSystem() {
      if (this.trainingSystemSelected == null) {
        this.reset()
        this.$store.commit('classReceiptsCourseSemester/SET_LISTTRAININGSYSTEMCOURSES', { data: [] })
        this.$store.commit('classReceiptsCourseSemester/SET_LISTCOURSEMAJORS', { data: [] })
        this.$store.commit('classReceiptsCourseSemester/SET_LISTCOURSEMAJORCLASSES', { data: [] })
        this.courseSelected = null
        this.majorSelected = null
        this.classSelect = null
      } else {
        this.getListTrainingSystemCourses({
          training_system_id: this.trainingSystemSelected,
        })
      }
    },
    onChangeCourse() {
      if (this.courseSelected == null) {
        this.reset()
        this.$store.commit('classReceiptsCourseSemester/SET_LISTCOURSEMAJORS', { data: [] })
        this.$store.commit('classReceiptsCourseSemester/SET_LISTCOURSEMAJORCLASSES', { data: [] })
        this.majorSelected = null
        this.classSelect = null
      } else {
        this.getListCourseMajors({
          course_id: this.courseSelected,
        })
      }
    },
    onChangeMajor() {
      if (this.majorSelected == null) {
        this.reset()
        this.$store.commit('classReceiptsCourseSemester/SET_LISTCOURSEMAJORCLASSES', { data: [] })
        this.classSelect = null
      } else {
        this.getListCourseMajorClasses({
          course_id: this.courseSelected,
          major_id: this.majorSelected,
        })
      }
    },
    async reset() {
      await this.$store.commit('classReceiptsCourseSemester/SET_DATA', { data: [] })
      this.itemsTable = this.dataLists
      this.$refs.table.refresh()
    },
    async onSelect() {
      this.isLoading = true
      try {
        await this.getData({
          course_id: this.courseSelected,
          class_id: this.classSelect,
          semester_id: this.semesterSelected,
          day_start: '',
          day_end: '',
          student_id: -1,
        })
        this.itemsTable = this.dataLists
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    exportExcel() {
      this.isLoading = true
      if (this.itemsTable.length > 0) {
        try {
          const tHeader = ['Mã sinh viên', 'Họ đệm', 'Tên', 'Ngày sinh', 'Lớp học', 'Ngành', 'Phải nộp', 'Miễn giảm', 'Tổng phải nộp', 'Trạng thái']
          const filterVal = ['student_code', 'last_name', 'first_name', 'birthday', 'class_name', 'major_name', 'total', 'total_exemption', 'amount', 'is_receipts']
          const dataJson = this.formatJson(filterVal, this.itemsTable)
          import('@/utils/Export2Excel').then(excel => {
            excel.export_json_to_excel({
              header: tHeader,
              data: dataJson,
              filename: 'Báo_cáo_tình_hình_nộp_học_phí_của_sinh_viên_theo_học_kỳ',
              autoWidth: true,
              bookType: 'xlsx',
            })
          })
        } catch (error) {
          showErrorToast(this, error)
        } finally {
          this.isLoading = false
        }
      } else {
        showErrorToast(this, 'Chưa thực hiện lấy danh sách phách')
        this.isLoading = false
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    // Call the API query method when the URL changes
    this.reset()
    next()
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
